import gameThumb1 from "../assets/img/gamejam/1.avif";
import gameThumb2 from "../assets/img/gamejam/2.avif";
import gameThumb3 from "../assets/img/gamejam/3.avif";
import gameThumb4 from "../assets/img/gamejam/qvtmvkhh.avif";
import gameThumb5 from "../assets/img/gamejam/thumbnail.avif";

export const DUMMY_GAMES = [
    {
        id: 1,
        sub_id: "demo-101",
        slug: "starforge-arena",
        title: "Starforge Arena",
        category: "Action",
        type: "Multiplayer",
        image: gameThumb1,
        distribution_url: "https://html5.gamedistribution.com/ee9c83bea86b4fdfa35a2aa1694fb5a6/",
        description: "Battle through neon arenas and upgrade your starship with rapid-fire loadouts.",
        instructions: "Use WASD or arrow keys to move and Space to fire. Survive as long as you can.",
        votes: 128,
        release_date: "2026-02-02"
    },
    {
        id: 2,
        sub_id: "demo-102",
        slug: "crimson-valley",
        title: "Crimson Valley",
        category: "Adventure",
        type: "Singleplayer",
        image: gameThumb2,
        distribution_url: "https://example.com/builds/crimson-valley/index.html",
        description: "A story-driven quest across foggy ruins and hidden temples.",
        instructions: "Explore with WASD, interact with E, and open the map with M.",
        votes: 86,
        release_date: "2026-01-18"
    },
    {
        id: 3,
        sub_id: "demo-103",
        slug: "logic-bloom",
        title: "Logic Bloom",
        category: "Puzzle",
        type: "Singleplayer",
        image: gameThumb3,
        distribution_url: "https://example.com/builds/logic-bloom/index.html",
        description: "Solve elegant grid puzzles to unlock the next bloom.",
        instructions: "Click tiles to rotate. Complete the pattern to advance.",
        votes: 54,
        release_date: "2025-12-10"
    },
    {
        id: 4,
        sub_id: "demo-104",
        slug: "quantum-kart",
        title: "Quantum Kart",
        category: "Racing",
        type: "Multiplayer",
        image: gameThumb4,
        distribution_url: "https://example.com/builds/quantum-kart/index.html",
        description: "Anti-gravity racing with boost pads and tight corners.",
        instructions: "Accelerate with W, brake with S, drift with Space.",
        votes: 210,
        release_date: "2026-03-01"
    },
    {
        id: 5,
        sub_id: "demo-105",
        slug: "skyline-tactics",
        title: "Skyline Tactics",
        category: "Strategy",
        type: "Singleplayer",
        image: gameThumb5,
        distribution_url: "https://example.com/builds/skyline-tactics/index.html",
        description: "Turn-based tactics above the clouds with aerial squads.",
        instructions: "Select units with mouse, confirm moves with Enter.",
        votes: 73,
        release_date: "2025-11-22"
    },
    {
        id: 6,
        sub_id: "demo-106",
        slug: "neon-drift",
        title: "Neon Drift",
        category: "Racing",
        type: "Multiplayer",
        image: gameThumb4,
        distribution_url: "https://example.com/builds/neon-drift/index.html",
        description: "Street drifting under neon lights with time-attack modes.",
        instructions: "Use arrow keys to steer, Space for handbrake.",
        votes: 141,
        release_date: "2026-02-20"
    },
    {
        id: 7,
        sub_id: "demo-107",
        slug: "rune-harbor",
        title: "Rune Harbor",
        category: "Adventure",
        type: "Singleplayer",
        image: gameThumb2,
        distribution_url: "https://example.com/builds/rune-harbor/index.html",
        description: "Dockside mysteries and rune puzzles in a haunted harbor.",
        instructions: "Move with WASD, interact with E, open journal with J.",
        votes: 62,
        release_date: "2026-01-05"
    },
    {
        id: 8,
        sub_id: "demo-108",
        slug: "circuit-break",
        title: "Circuit Break",
        category: "Action",
        type: "Multiplayer",
        image: gameThumb1,
        distribution_url: "https://example.com/builds/circuit-break/index.html",
        description: "Fast-paced combat arenas with team-based objectives.",
        instructions: "Use WASD to move, Shift to dash, mouse to aim.",
        votes: 191,
        release_date: "2026-03-12"
    },
    {
        id: 9,
        sub_id: "demo-109",
        slug: "glyph-tower",
        title: "Glyph Tower",
        category: "Puzzle",
        type: "Singleplayer",
        image: gameThumb3,
        distribution_url: "https://example.com/builds/glyph-tower/index.html",
        description: "Climb the tower by solving layered glyph challenges.",
        instructions: "Click to select glyphs, rotate with Q/E.",
        votes: 39,
        release_date: "2025-10-29"
    },
    {
        id: 10,
        sub_id: "demo-110",
        slug: "driftline",
        title: "Driftline",
        category: "Racing",
        type: "Multiplayer",
        image: gameThumb4,
        distribution_url: "https://example.com/builds/driftline/index.html",
        description: "Precision racing on narrow tracks with dynamic weather.",
        instructions: "W to accelerate, A/D to steer, Space to drift.",
        votes: 98,
        release_date: "2026-02-10"
    },
    {
        id: 11,
        sub_id: "demo-111",
        slug: "ember-raiders",
        title: "Ember Raiders",
        category: "Action",
        type: "Multiplayer",
        image: gameThumb1,
        distribution_url: "https://example.com/builds/ember-raiders/index.html",
        description: "Squad-based arena shooter with fast respawn rounds.",
        instructions: "WASD to move, Shift to sprint, mouse to aim.",
        votes: 164,
        release_date: "2026-03-05"
    },
    {
        id: 12,
        sub_id: "demo-112",
        slug: "mistwood-chronicle",
        title: "Mistwood Chronicle",
        category: "Adventure",
        type: "Singleplayer",
        image: gameThumb2,
        distribution_url: "https://example.com/builds/mistwood-chronicle/index.html",
        description: "Explore a haunted forest and uncover lost memories.",
        instructions: "Move with WASD, interact with E, inventory with I.",
        votes: 71,
        release_date: "2026-02-08"
    },
    {
        id: 13,
        sub_id: "demo-113",
        slug: "circuit-pulse",
        title: "Circuit Pulse",
        category: "Racing",
        type: "Multiplayer",
        image: gameThumb4,
        distribution_url: "https://example.com/builds/circuit-pulse/index.html",
        description: "High-speed circuit racing with boost chaining.",
        instructions: "W to accelerate, A/D to steer, Space to boost.",
        votes: 119,
        release_date: "2026-01-30"
    },
    {
        id: 14,
        sub_id: "demo-114",
        slug: "cipher-garden",
        title: "Cipher Garden",
        category: "Puzzle",
        type: "Singleplayer",
        image: gameThumb3,
        distribution_url: "https://example.com/builds/cipher-garden/index.html",
        description: "Decode glyphs to restore a forgotten garden.",
        instructions: "Click to select glyphs, rotate with Q/E.",
        votes: 47,
        release_date: "2025-12-18"
    },
    {
        id: 15,
        sub_id: "demo-115",
        slug: "frontline-saga",
        title: "Frontline Saga",
        category: "Strategy",
        type: "Singleplayer",
        image: gameThumb5,
        distribution_url: "https://example.com/builds/frontline-saga/index.html",
        description: "Command squads in tactical skirmishes.",
        instructions: "Select units with mouse, confirm actions with Enter.",
        votes: 82,
        release_date: "2026-02-14"
    },
    {
        id: 16,
        sub_id: "demo-116",
        slug: "galaxy-couriers",
        title: "Galaxy Couriers",
        category: "Action",
        type: "Singleplayer",
        image: gameThumb1,
        distribution_url: "https://example.com/builds/galaxy-couriers/index.html",
        description: "Deliver cargo through asteroid belts and hostile zones.",
        instructions: "Use arrow keys to steer, Space to boost.",
        votes: 103,
        release_date: "2026-03-18"
    }
];
